module.exports = __webpack_public_path__ + "img/3.b31c88e4.png";